import { RewardsComingSoon } from "@/components/rewards/RewardsComingSoon";

/**
 * Rewards approval queue (formerly the SPIF approval queue) — parked behind a
 * "coming soon" placeholder per CHP-430. The old SpifList queue UI stays on disk
 * (components/spifs/*) for later revival, but this route renders the
 * placeholder. Rewards is NOT cancelled — see ADR-0033 (supersedes ADR-0031 §4)
 * and workboard decisions/portfolio-gaps-decisions.md (D1).
 */
export function ManagerSpifsQueueRoute() {
  return <RewardsComingSoon audience="admin" />;
}
